// extracted by mini-css-extract-plugin
export default {"image":"image__zUvAV","fieldImage":"fieldImage__DmguD","imageWrapper":"imageWrapper__AFEx5","loading":"loading__2Fy6L","loadingLoaded":"loadingLoaded__RnMcf"};